import { translate, translateFormatter } from '@/domains/core/localization/translate';
export { ratingCountLabel } from '@/domains/productDiscovery/Listings/components/Filters/components/RatingsFilter/components/Ratings/Ratings';
export const translations = translate({
  "title": "Selected filter(s)",
  "reset": "Reset all"
});
export const rangeFilter = translateFormatter<{
  label: string;
  min: number;
  max: number;
  unit: string;
}>([{
  "type": 1,
  "value": "label"
}, {
  "type": 0,
  "value": ": "
}, {
  "type": 1,
  "value": "min"
}, {
  "type": 0,
  "value": " to "
}, {
  "type": 1,
  "value": "max"
}, {
  "type": 1,
  "value": "unit"
}], undefined, undefined, "en");
export const rangeFilterMinOnly = translateFormatter<{
  label: string;
  min: number;
  unit: string;
}>([{
  "type": 1,
  "value": "label"
}, {
  "type": 0,
  "value": ": until "
}, {
  "type": 1,
  "value": "min"
}, {
  "type": 1,
  "value": "unit"
}], undefined, undefined, "en");
export const rangeFilterMaxOnly = translateFormatter<{
  label: string;
  max: number;
  unit: string;
}>([{
  "type": 1,
  "value": "label"
}, {
  "type": 0,
  "value": ": less than "
}, {
  "type": 1,
  "value": "max"
}, {
  "type": 1,
  "value": "unit"
}], undefined, undefined, "en");